import styled, { StyledComponent } from 'styled-components';

export const StyledWrapper = styled.div`
  width: 100%;
  background: #ffffff;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
`;

export const Tips = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #949494;
`;

export const StyledButton: StyledComponent<
  'div',
  any,
  { type?: 'primary'; disabled?: boolean }
> = styled.div<{ type?: 'primary'; disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  gap: 2px;
  height: 28px;
  border-radius: 2px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  white-space: nowrap;

  background: ${(props) => (props.type === 'primary' ? '#0046FF' : '#FFFFFF')};
  color: ${(props) => (props.type === 'primary' ? '#FFFFFF' : '#0046FF')};

  ${(props) => (props.type === 'primary' ? '' : 'border: 1px solid #0046FF;')}

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
`;
